/*
 * newsbot - Queue action component
 */

import { FilterSection, FilterLayout } from "@/components/filters/_components";
import { TextField } from "@components/inputs";

interface QueueProps {
  idx: number;
}

export const Queue = ({ idx }: QueueProps) => (
  <FilterSection
    title="Queue"
    subtitle="Add matching stories to a processing queue"
  >
    <FilterLayout>
      <TextField
        name={`actions.${idx}.queue_name`}
        label="Queue Name"
        placeholder="high-priority"
        tooltip={
          <div>
            <p>Name of the queue to add stories to for batch processing.</p>
          </div>
        }
      />
    </FilterLayout>
  </FilterSection>
);
